import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { CloseReason, SnackbarKey, useSnackbar } from 'notistack';

import { notificationsSelector } from '@store/features/notifications/selectors';
import { removeSnackbar } from '@store/features/notifications/slice';
import useDispatch from '@store/hooks/useDispatch';

const Toast: FC = () => {
  const dispatch = useDispatch();
  const notifications = useSelector(notificationsSelector);

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    notifications.forEach(({ message, options = {} }: any) => {
      enqueueSnackbar(message, {
        ...options,
        onClose: (
          event: React.SyntheticEvent<any> | null,
          reason: CloseReason,
          key: SnackbarKey,
        ) => {
          if (options.onClose) {
            options.onClose(event, reason, key);
          }
        },
        onExited: (event: never, key: SnackbarKey) => {
          dispatch(removeSnackbar(key));
        },
      });
    });
  }, [dispatch, enqueueSnackbar, notifications]);

  return null;
};

export default Toast;
